import React, { Component } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';

// Decorat
import { withWindow } from '../../decorators/window';

// Utils
import { isHomeLocation } from '../../utilities/helpers';
// Constants
import { get } from 'lodash';
import { getCMSUrl, getCMSHome, getCMSUrlToHome, getCMSUrlToPromotions } from '../../constants/cms-urls';

// Components
import HeaderMenuBook from './header-menu-book';
import HeaderMenuMyTrips from './header-menu-my-trips';
import HeaderAccordionAnimated  from './header-accordion-animated';
import TranslatedCopy from '../../intl/translated-copy';
import Pictogram from './pictogram';
import { connect } from 'react-redux';

// UI Models
function stopPropagation(e) {
  e.stopPropagation();
} 

const mapStateToProps = state => ({
  // Menu promotions e info
  menuPromotions: state.MenuPromotions.menuPromotions,
  storefront : state.Manage.storefront,
  travelInformation: state.TravelInformation.travelInformation,
  
});

class HeaderMenuHamburger extends Component {
  static defaultProps = {
    shouldShowStorefront: true,
  }

  constructor(props) {
    super(props);

    this.handleStorefrontClick = this.handleStorefrontClick.bind(this);
    this.handleSaveStorefront =  this.handleSaveStorefront.bind(this);
    this.handleProfileClick = this.handleProfileClick.bind(this);

    /**
     * @type {Object}
     * @prop {Boolean} isStorefrontActive - User has selected storefront in menu
     * @prop {Boolean} showBookMenu - User toggled book links
     * @prop {Boolean} showMyTripsMenu - User toggled my trips links
     */
    this.state = {
      isStorefrontActive: false,
      kindPromotions: '',
      showBookMenu: false,
      showMyTripsMenu: false,
      showProfileMenu: false,
      showingProfile: false,
      subMenuType: null,
    };
  }

  render() {
    const { breakpoint, type, showHamburger, closeHamburger } = this.props;
    const { showBookMenu, showMyTripsMenu } = this.state;

    const isSmallBreakpoint = breakpoint === 'small';
    const isBookMenuOpen = showBookMenu && isSmallBreakpoint;
    const isMyTripsMenuOpen = showMyTripsMenu && isSmallBreakpoint;
    
    const backDropClasses = cx({
      'HeaderMenuHamburger-backDrop': true,
      'HeaderMenuHamburger-backDrop--hidden': !showHamburger,
    });

    const classes = cx({
      'HeaderMenuHamburger': true,
      'HeaderMenuHamburger--booker': type === 'booker',
      'HeaderMenuHamburger--slide-in': showHamburger,
      'HeaderMenuHamburger--slide-out': !showHamburger,
      'is-bookMenuOpen': isBookMenuOpen,
      'is-myTripsMenuOpen': isMyTripsMenuOpen,
      'HeaderMenuHamburger--overflow': false,
    });

    const styleMenuMobile = {
      top: 0 + 60,
      height: window.innerHeight - (0 + 60),
    };

    return (
      <div className={ backDropClasses }
        onClick={ closeHamburger }
        style={ styleMenuMobile }>
        { this.renderSubmenu() }
        <div
          className={ classes }
          onClick={ stopPropagation }
          ref={ (ref) => this.HeaderHamburgerScrollDOM = ref }
          style={ styleMenuMobile }>
          { isBookMenuOpen ? this.renderBookMenuHeader() : null }
          { isMyTripsMenuOpen ? this.renderMyTripsMenuHeader() : null }
          { type === 'main' ? this.renderHamburgerMain() : null }
          { type === 'booker' ? this.renderHamburgerBooker() : null }
        </div>
      </div>
    );
  }

  renderBookMenuHeader() {
    const { closeHamburger } = this.props;
    const { showBookMenu } = this.state;

    const headerClasses = cx({
      'HeaderMenuHamburger-bookMenuHeader': true,
      'HeaderMenuHamburger-bookMenuHeader--book': showBookMenu,
    });

    return (
      <div className={ headerClasses }>
        <button
          className='HeaderMenuHamburger-bookMenuHeaderBack Icon Icon--arrowSmallLeft'
          onClick={ this.handleToggleBookMenu }>
          <TranslatedCopy copyID='APP_BOOK' />
        </button>
        <button
          aria-label='Expand Nav'
          className='HeaderMenuHamburger-bookMenuHeaderClose Icon Icon--xThin'
          onClick={ closeHamburger }></button>
      </div>
    );
  }

  renderMyTripsMenuHeader() {
    const { closeHamburger } = this.props;
    const { showMyTripsMenu } = this.state;

    const headerClasses = cx({
      'HeaderMenuHamburger-bookMenuHeader': true,
      'HeaderMenuHamburger-bookMenuHeader--book': showMyTripsMenu,
    });

    return (
      <div className={ headerClasses }>
        <button
          className='HeaderMenuHamburger-bookMenuHeaderBack Icon Icon--arrowSmallLeft'
          onClick={ this.handleToggleMyTripsMenu }>
          <TranslatedCopy copyID='APP_MY_TRIPS' />
        </button>
        <button
          aria-label='Expand Nav'
          className='HeaderMenuHamburger-bookMenuHeaderClose Icon Icon--xThin'
          onClick={ closeHamburger }></button>
      </div>
    );
  }

  renderHamburgerMain() {
    const { breakpoint } = this.props;

    const { showBookMenu, showMyTripsMenu } = this.state;
    const isSmallBreakpoint = breakpoint === 'small';
    const isBookMenuOpen = showBookMenu && isSmallBreakpoint;
    const isMyTripsMenuOpen = showMyTripsMenu && isSmallBreakpoint;
    const isMyTripsMenuOpenConditional = isMyTripsMenuOpen ? this.renderHamburgerMyTripsLinks() : this.renderHamburgerMainLinks();
    
    return isBookMenuOpen ? this.renderHamburgerBookLinks() : isMyTripsMenuOpenConditional;
  }

  renderHamburgerMainLinks() {
    return (
      <div>
        { this.renderLinksMain() }
      </div>
    );
  }

  renderHamburgerBookLinks() {
    const {
      bookMenuType,
      isAdvancedBooking,
      orientation,
      storefront,
    } = this.props;

    const innerHeight = window.innerHeight - 60;

    return (
      <HeaderMenuBook
        bookMenuType={ bookMenuType }
        menuBookStyle={ orientation === 'portrait' ? { height: innerHeight } : {} }
        className='HeaderMenuBook--inHamburger'
        isAdvancedBooking={ isAdvancedBooking } 
        storefront= { storefront }/>
    );
  }

  renderHamburgerMyTripsLinks() {
    const {
      orientation,
      storefront,
    } = this.props;

    const innerHeight = window.innerHeight - 60;

    return (
      <HeaderMenuMyTrips
        menuBookStyle={ orientation === 'portrait' ? { height: innerHeight } : {} }
        className='HeaderMenuBook--inHamburger'
        storefront={ storefront } />
    );
  }

  renderHamburgerBooker() {
    return (
      <div>
        {/* this.renderLinksBooker() */}
        { this.renderHelp() }
      </div>
    );
  }

  renderLinksMain() {
    const {
      activateUserLogin,
      breakpoint,
      breakpointNewDesign,
      isSignedIn,
      language,
      closeHamburger,
      country,
      storefront,
      storefrontData,
      menuPromotions,
      travelInformation,
    } = this.props;
    const [ 
      languageSF,
      countrySF,
    ] = storefront.split('-');
    const isSmallBreakpoint = breakpointNewDesign === 'small';
    const switchNewLook = storefrontData?.activePnrLookUpLight;

    const staticLinks = (
      <>
        { storefrontData?.staticLinks?.headerFlightStatus?.length > 0 ? (
          <li key={ 4 }>
            <a
              onClick={ closeHamburger }
              href={ getCMSUrlToHome(country, language, storefrontData.staticLinks.headerFlightStatusUrl) }
              className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
              <span>{ storefrontData?.staticLinks?.headerFlightStatus }</span>
            </a>
          </li>
        ) : null }
        { storefrontData?.staticLinks?.headerAdditionalOptionUrl && storefrontData?.staticLinks?.headerAdditionalOption?.length > 0 ? (
          <li key={ 5 }>
            <a
              onClick={ closeHamburger }
              href={ getCMSUrlToHome(country, language, storefrontData?.staticLinks?.headerAdditionalOptionUrl) }
              className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
              <span>{ storefrontData?.staticLinks?.headerAdditionalOption }</span>
            </a>
          </li>
        ) : null }
      </>
    );
    const commonLinks = (
      <ul className='HeaderMenuHamburger-linksList--principalMenu HeaderMenuHamburger-linkList--primary'>
        <li key={ 0 }>
          <a onClick={ closeHamburger } href={ getCMSHome(country, language) } 
            className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
            <TranslatedCopy copyID='APP_HOME' />
          </a>
        </li>
        <li key={ 1 }>
          <a onClick={ closeHamburger } href={ getCMSUrl(country, language, 'BOOK') } 
            className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
            <TranslatedCopy copyID='APP_BOOK' />
          </a>
        </li>
        {
          switchNewLook ?
            <li key={ 2 }>
              <a onClick={ closeHamburger } href={ getCMSUrl(country, language, 'MANAGE_YOUR_BOOKING') }
                className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
                <TranslatedCopy copyID='APP_MY_FLIGHT' />
              </a>
            </li>
            :
            <>
              <li key={ 2 }>
                <a onClick={ closeHamburger }
                  href={ getCMSUrl(country, language, 'MANAGE_YOUR_BOOKING') }
                  className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
                  <TranslatedCopy copyID='APP_MY_TRIPS' />
                </a>
              </li>
              <li key={ 3 }>
                <a onClick={ closeHamburger } href={ getCMSUrl(countrySF, languageSF, 'CHECK_IN') }
                  className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
                  <TranslatedCopy copyID='APP_CHECK_IN' />
                </a>
              </li>
            </>
        }
        { staticLinks }
      </ul>
    );

    return (
      <div className='HeaderMenuHamburger-wrapLinksList'>
        { isSmallBreakpoint ?
          <section>
            <div className='HeaderMenuHamburger-titlePrincipal'>
              <TranslatedCopy copyID='MENU_PRINCIPAL_TITLE' tagName='p' />
            </div>
            { breakpoint === 'small' && activateUserLogin && country === 'mx' || breakpoint === 'medium' 
              && activateUserLogin && country === 'mx' ? 
              isSignedIn ?
                this.renderProfileSignedIn() :
                this.renderProfileSignedOut() : null 
            }
            { commonLinks }
            { Object.keys(menuPromotions).length > 0 ?
              <div>
                <div className='HeaderMenuHamburger-titlePrincipal'>
                  <TranslatedCopy 
                    copyID='MENU_VIAJA_TITLE' 
                    tagName='p' 
                  />
                </div>
                <ul className='HeaderMenuHamburger-linksList HeaderMenuHamburger-linksList--secondary'>
                  { Object.keys(menuPromotions).length > 0 ?
                    <li className='HeaderMenuHamburger-linkItemSecondary'>
                      <button className='HeaderMenuHamburger-linkItemSecondary--option' 
                        onClick={ () => this.handleSubmenuClick('promotions') }
                      >
                        <span className='Icon Icon--promotions'></span>
                        <TranslatedCopy 
                          className='HeaderMenuHamburger-menuTitle'
                          copyID='APP_PROMOTIONS' 
                        />
                      </button>
                    </li> : null
                  }
                  { Object.keys(travelInformation).length > 0 ?
                    <li className='HeaderMenuHamburger-linkItemSecondary'>
                      <button 
                        className='HeaderMenuHamburger-linkItemSecondary--option' 
                        onClick={ () => this.handleSubmenuClick('travelInformation') }
                      >
                        <span className='Icon Icon--travel_information'></span>
                        <TranslatedCopy 
                          copyID='APP_FLIGHT_INFORMATION'
                        />
                      </button>
                    </li> : null
                  }
                </ul>
              </div> : null
            }
          </section>
          :
          <section>
            {  Object.keys(menuPromotions).length > 0 ? this.renderMenuPromotions() : null  }
            {  Object.keys(travelInformation).length > 0 ? this.renderMenuTravelInformation() : null }
            
          </section>
        }
      </div>
    );
  }

  renderSubmenu() {
    const {
      isSubmenuOpen,
      menuPromotions,
      travelInformation,
      language,
      storefront,
    } = this.props;
    
    const { subMenuType } = this.state;
    
    const hasTravelAdvisory =  false;
    const validateIsHome = isHomeLocation(language, storefront);
    const mainInfo = Object.keys(menuPromotions).length > 0 && subMenuType === 'promotions' ? menuPromotions.main : 
      Object.keys(travelInformation) && subMenuType === 'travelInformation' ? (travelInformation.main) : {} ;
      
    const classes = cx({
      'HeaderMenuHamburger-submenu': true,
      'HeaderMenuHamburger-submenu--slide-in': isSubmenuOpen,
      'HeaderMenuHamburger-submenu--slide-out':!isSubmenuOpen,
      'has-travelAdvisory': hasTravelAdvisory && validateIsHome,
    });
    const mainInfoFixedClasses = cx({
      'HeaderMenuPromotions-mainInfo-mobile': true,
      'HeaderMenuHamburger-mainInfo--slide-in': isSubmenuOpen,
      'HeaderMenuHamburger-mainInfo--slide-out': !isSubmenuOpen,
    });

    const headerId = document.getElementById('HeaderId');
    const heightMenu = headerId ? headerId.clientHeight : 0;

    const styleMenuMobile = {
      top: heightMenu + 0,
      height: window.innerHeight - (heightMenu + 0),
    };

    return (
      <div
        className={ classes }
        onClick={ stopPropagation }
        style={ styleMenuMobile }>
        <div>
          { Object.keys(menuPromotions).length > 0 && subMenuType === 'promotions' ? this.renderMenuPromotions() : null }
          { Object.keys(travelInformation).length > 0 && subMenuType === 'travelInformation' ? this.renderMenuTravelInformation() : null } 
          <div className={ mainInfoFixedClasses }>
            { Object.keys(mainInfo).length > 0 ? this.renderMainInfoMobile(mainInfo) : null }
          </div>
        </div>
      </div>
    );
  }

  handleSubmenuClick = (subMenuType) => {
    const { onOpenSubmenu } = this.props;
    onOpenSubmenu ();

    this.setState({
      subMenuType: subMenuType,
    });
  }
  handleSubmenuBack = () => {
    const { onCloseSubmenu } = this.props;

    onCloseSubmenu();

    setTimeout(() => {
      this.setState({
        subMenuType: null,
        isExpanded: false,
        selectedMenu: null,
      });
    }, 500);
  }
  renderMenuPromotions() {
    const {
      breakpointNewDesign,
      menuPromotions,
      storefront,
    } = this.props;
    const {
      selectedMenu,
    } = this.state;
    const mainInfo = menuPromotions.main || {};
    const moreOptionsPromotions = menuPromotions.right || [];
    const centerColumnOnePromotions = get(menuPromotions, 'center.columnOne', []);
    const centerColumnTwoPromotions = get(menuPromotions, 'center.columnTwo', []);
    const titleColumn1Promotions = get(menuPromotions, 'center.columnOneTitle', '');
    const titleColumn2Promotions = get(menuPromotions, 'center.columnTwoTitle', '');
  
    return (
      <div>
        <div className='HeaderMenuHamburger-menuPromotion'>
          {
            breakpointNewDesign === 'small' ? <button
              className='HeaderMenuHamburger-menuPromotion--btnBack'
              onClick={ () => this.handleSubmenuBack() }>
              <span className='Icon Icon--arrowLeftBold'></span>
            </button> : null
          }
          <TranslatedCopy className='HeaderMenuHamburger-menuTitle' copyID='APP_PROMOTIONS' />
        </div>

        <div className='HeaderMenuHamburger-menuPromotion--wrapper'>
          
          { breakpointNewDesign !== 'small' && mainInfo.mainLinkUrl && mainInfo.mainLinkUrl.length > 0 ? this.renderMainInfoMobile(mainInfo) : null }

          { Object.keys(moreOptionsPromotions).length > 0 ?
            <ul className='HeaderMenuHamburger-promotionsLinks'>
              {
                moreOptionsPromotions.map((option, index) => {
                  if (option.rightLinkUrl) {
                    const urlPromotions = (option.rightLinkUrl).includes('https');

                    return (
                      <li className='HeaderMenuHamburger-promotionsLinksItem' key={`option_${ index }`}>
                        <a
                          className='HeaderMenuPromotions-IconLinksList-link'
                          onClick={ () => this.trackMenuClick({ i: index, value: option }) }
                          href={ urlPromotions ? option.rightLinkUrl : getCMSUrlToPromotions(storefront, option.rightLinkUrl)}
                        >
                          <div className='HeaderMenuPromotions-IconLinksList-container'>
                            <img src={ option.rightLinkImg && option.rightLinkImg.rightLinkUrl }
                              alt={ (get(option, 'rightLinkImg.rightLinkAlt', '').length > 0 ? get(option, 'rightLinkImg.rightLinkAlt', '') : option.rightLinkCta) } />
                            { option.rightLinkCta }
                          </div>
                        </a>
                      </li>
                    );
                  }
                })
              }
            </ul> : null
          }

          { (titleColumn1Promotions && titleColumn1Promotions.length > 0) || (titleColumn2Promotions && titleColumn2Promotions.length > 0) ?
            <ul className='HeaderMenuPromotions-menuAccordionList'>
              {
                Object.keys(centerColumnOnePromotions).length > 0 && titleColumn1Promotions && titleColumn1Promotions.length > 0 ?
                  <li className={ `HeaderMenuPromotions-menuAccordionItem ${ selectedMenu === 'promotions1' ? 'HeaderMenuPromotions-menuAccordionItem--selected' : '' }` } key='promotions1'>
                    <HeaderAccordionAnimated
                      breakpoint={ breakpointNewDesign }
                      headerTitle='APP_PROMOTIONS'
                      handleExpandArrowClick={() => this.handleExpandArrowClick('promotions1') }
                      isExpanded={ selectedMenu === 'promotions1' }
                      identifier='promotions1'
                      renderContent={ centerColumnOnePromotions }
                      titleColumn={ titleColumn1Promotions }
                    />
                  </li> : null
              }
              {
                Object.keys(centerColumnTwoPromotions).length > 0 && titleColumn2Promotions && titleColumn2Promotions.length > 0 ?
                  <li className={ `HeaderMenuPromotions-menuAccordionItem ${ selectedMenu === 'promotions2' ? 'HeaderMenuPromotions-menuAccordionItem--selected' : '' }` } key='promotions2'>
                    <HeaderAccordionAnimated
                      breakpoint={ breakpointNewDesign }
                      handleExpandArrowClick={() => this.handleExpandArrowClick('promotions2') }
                      headerTitle='APP_PROMOTIONS'
                      isExpanded={ selectedMenu === 'promotions2' }
                      identifier='promotions2'
                      renderContent={ centerColumnTwoPromotions }
                      titleColumn={ titleColumn2Promotions }
                    />
                  </li> : null
              }
            </ul> : null
          }
        </div>
      </div>
    );
  }

  trackMenuClick = ( urlId ) => {
    const { value } = urlId;
    this.setState({
      kindPromotions: value,
    });
  };

  renderMainInfoMobile = (mainInfo) => {
    const { storefront } = this.props;

    
    if (Object.keys(mainInfo).length === 0 ) return null;
    const urlTrial = (mainInfo.mainLinkUrl).includes('https');

    return (
      <a
        className='HeaderMenuHamburger-mainInfo-wrapper'
        onClick={ () => this.trackMenuClick({  i: 'fligths', value: mainInfo.mainLinkUrl }) }
        href={ urlTrial ? mainInfo.mainLinkUrl : getCMSUrlToPromotions(storefront, mainInfo.mainLinkUrl) }
        link={ mainInfo.mainLinkUrl || '' }
      >
        { mainInfo.mainLinkUrl && mainInfo.mainLinkUrl.length > 0 ?
          <div className='HeaderMenuHamburger-mainInfo-content'>
            <div className='HeaderMenuHamburger-mainInfo-image-wrapper'>
              {
                mainInfo && mainInfo.mainIconMobile && mainInfo.mainIconMobile.mainIconMobileUrl ?
                  <img src={ mainInfo.mainIconMobile.mainIconMobileUrl }
                    alt={ mainInfo.mainIconMobile && mainInfo.mainIconMobile.mainIconMobileAlt || '' }
                    className='HeaderMenuHamburger-mainInfo-image'/> : null
              }
              <p className={ `HeaderMenuHamburger-mainInfo-title HeaderMenuHamburger-mainInfo-title--${ mainInfo.mainLinkColor }` }>{ mainInfo.mainMobileDescription || '' }</p>
            </div>
            <p className='HeaderMenuHamburger-mainInfo-description'>{ mainInfo.mainLinkTitle || '' }</p>
          </div> : null }
        <span className='Icon '></span>
      </a>
    );
  }

  handleExpandArrowClick = (key) => {
    const { selectedMenu } = this.state;

    this.setState({
      isExpanded: key === selectedMenu,
      selectedMenu: key === selectedMenu ? false : key,
    });
  }

  renderMenuTravelInformation = () => {
    const {
      breakpointNewDesign,
      travelInformation,
      storefront,
    } = this.props;
    const {
      selectedMenu,
    } = this.state;

    
    const mainInfo = travelInformation.main || {};
    const moreOptionsTravelInfo = travelInformation.right || [];
    const centerColumnOneTravelInfo = get(travelInformation, 'center.columnOne', []);
    const centerColumnTwoTravelInfo = get(travelInformation, 'center.columnTwo', []);
    const titleColumn1TravelInfo = get(travelInformation, 'center.columnOneTitle', '');
    const titleColumn2TravelInfo = get(travelInformation, 'center.columnTwoTitle', '');
    
    return (
      <div >
        <div className='HeaderMenuHamburger-menuPromotion'>
          {
            breakpointNewDesign === 'small' ? <button
              className='HeaderMenuHamburger-menuPromotion--btnBack'
              onClick={ () => this.handleSubmenuBack() }>
              <span className='Icon Icon--arrowLeftBold'></span>
            </button> : null
          }
          <TranslatedCopy className='HeaderMenuHamburger-menuTitle' copyID='APP_FLIGHT_INFORMATION' />
        </div>

        <div className='HeaderMenuHamburger-menuPromotion--wrapper'>
          { breakpointNewDesign !== 'small' && mainInfo.mainLinkUrl && mainInfo.mainLinkUrl.length > 0 ? this.renderMainInfoMobile(mainInfo) : null }

          { Object.keys(moreOptionsTravelInfo).length > 0 ?
            <ul className='HeaderMenuHamburger-promotionsLinks'>
              {
                moreOptionsTravelInfo.map((option, index) => {
                  if (option.rightLinkUrl) {
                    const urlPromotions = (option.rightLinkUrl).includes('https');
                  
                    return (
                      <li className='HeaderMenuHamburger-promotionsLinksItem' key={ `option_${ index }` }>
                        <a
                          className='HeaderMenuPromotions-IconLinksList-link'
                          onClick={ () => this.trackMenuClick({ i: index, value: option.rightLinkUrl }) }
                          href={ urlPromotions ? option.rightLinkUrl : getCMSUrlToPromotions(storefront, option.rightLinkUrl) }
                        >
                          <div className='HeaderMenuPromotions-IconLinksList-container'>
                            <img src={ option.rightLinkImg && option.rightLinkImg.rightLinkUrl }
                              alt={ (get(option, 'rightLinkImg.rightLinkAlt', '').length > 0 ? get(option, 'rightLinkImg.rightLinkAlt', '') : option.rightLinkCta) } />
                            { option.rightLinkCta }
                          </div>
                        </a>
                      </li>
                    );
                  }
                })
              }
            </ul> : null
          }

          { (titleColumn1TravelInfo && titleColumn1TravelInfo.length > 0) || (titleColumn2TravelInfo && titleColumn2TravelInfo.length > 0) ?
            <ul className='HeaderMenuPromotions-menuAccordionList'>
              { Object.keys(centerColumnOneTravelInfo).length > 0 && titleColumn1TravelInfo && titleColumn1TravelInfo.length > 0 ?
                <li className={ `HeaderMenuPromotions-menuAccordionItem ${ selectedMenu === 'travelInformation1' ? 'HeaderMenuPromotions-menuAccordionItem--selected' : '' }` } key='travelInformation1'>
                  <HeaderAccordionAnimated
                    breakpoint={ breakpointNewDesign }
                    handleExpandArrowClick={() => this.handleExpandArrowClick('travelInformation1') }
                    headerTitle='APP_PROMOTIONS'
                    identifier='travelInformation1'
                    isExpanded={ selectedMenu === 'travelInformation1' }
                    renderContent={ centerColumnOneTravelInfo }
                    titleColumn={ titleColumn1TravelInfo }
                  />
                </li> : null }
              { Object.keys(centerColumnTwoTravelInfo).length > 0 && titleColumn2TravelInfo && titleColumn2TravelInfo.length > 0 ?
                <li className={ `HeaderMenuPromotions-menuAccordionItem ${ selectedMenu === 'travelInformation2' ? 'HeaderMenuPromotions-menuAccordionItem--selected' : '' }` } key='travelInformation2'>
                  <HeaderAccordionAnimated
                    breakpoint={ breakpointNewDesign }
                    handleExpandArrowClick={() => this.handleExpandArrowClick('travelInformation2') }
                    headerTitle='APP_PROMOTIONS'
                    identifier='travelInformation2'
                    isExpanded={ selectedMenu === 'travelInformation2' }
                    renderContent={ centerColumnTwoTravelInfo }
                    titleColumn={ titleColumn2TravelInfo }
                  />
                </li> : null }
            </ul> : null
          }
        </div>
      </div>
    );
  }

  renderLinksBooker() {
    const { isSignedIn } = this.props;

    return (
      <div className='HeaderMenuHamburger-wrapLinksList'>
        <ul className='HeaderMenuHamburger-linksList HeaderMenuHamburger-linkList--primary'>
          { !isSignedIn ?
            <li>
              <Link to='/login'
                className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
                <TranslatedCopy copyID='APP_LOGIN' />
              </Link>
            </li> : null }
          <li>
            <Link to='/currency'
              className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'>
              <TranslatedCopy copyID='APP_CURRENCY' />
              <span className='HeaderMenuHamburger-linkCurrency'>$MXN</span>
            </Link>
          </li>
        </ul>
      </div>
    );
  }

  renderProfileSignedOut() {
    const { onSignInClick } = this.props;

    return (
      <div className='HeaderMenuHamburger-Signouticon'>
        <Pictogram id='loginProfile' className='HeaderMenuHamburger-icon' />
        <ul className='HeaderMenuHamburger-linksList HeaderMenuHamburger-linksList--tertiary'>
          <li>
            <button
              className='HeaderMenuHamburger-link HeaderMenuHamburger-link--primary'
              onClick={ onSignInClick }>
              <TranslatedCopy copyID='APP_LOGIN' />
            </button>
          </li>
        </ul>
      </div>
    );
  }


  renderProfileSignedIn() {
    const { showProfileMenu } = this.state;
    return (
      <div className='HeaderMenuHamburger-storefront'>
        { showProfileMenu ? this.renderProfileSelect() : this.renderProfilefrontDisplay() }
      </div>
    );
  }

  renderProfilefrontDisplay() {
    const {
      userData,
    } = this.props;

    return (
      <button
        className='HeaderMenuHamburger-storefrontDisplay Icon Icon--arrowSmallDown'
        onClick={ this.handleProfileClick }>
        <div className='Header-row'>
          <div className='Header-userIconb'>{ userData.getPassengerInitials() }</div>
          <TranslatedCopy
            copyID='PROFILE_HI'
            user={ userData.firstName }
            tagName='span' />
        </div>
      </button>
    );
  }

  renderProfileSelect() {
    const {
      onProfileLinkClick,
      userData,
      closeHamburger,
    } = this.props;

    return (
      <div>
        <button
          className='HeaderMenuHamburger-storefrontDisplay Icon Icon--arrowSmallDown'
          onClick={ this.handleProfileClick }>
          <div className='Header-row'>
            <div className='Header-userIconb'>{ userData.getPassengerInitials() }</div>
            <TranslatedCopy
              copyID='PROFILE_HI'
              user={ userData.firstName }
              tagName='span' />
          </div>
        </button>
        <ul className='HeaderMenuHamburger-profileList' onClick={ closeHamburger }>
          <li>
            <Link
              to={ 'url(storefront, language, routeCodes.USER_PROFILE_HOME)' }
              onClick={ () => onProfileLinkClick(0) }
              className='HeaderMenuHamburger-link HeaderMenuHamburger-link--secondary'>
              <TranslatedCopy copyID='NS_MYB_HEADER' />
            </Link>
          </li>
          <li>
            <Link
              to={ 'url(storefront, language, routeCodes.USER_PROFILE_HOME)' }
              onClick={ () => onProfileLinkClick(1) }
              className='HeaderMenuHamburger-link HeaderMenuHamburger-link--secondary'>
              <TranslatedCopy copyID='USER_PROFILE_MY_AEROMEXICO' />
            </Link>
          </li>
          <li>
            <Link
              to={ 'url(storefront, language, routeCodes.USER_PROFILE_HOME)' }
              onClick={ () => onProfileLinkClick(2) }
              className='HeaderMenuHamburger-link HeaderMenuHamburger-link--secondary'>
              <TranslatedCopy copyID='USER_PROFILE_MY_TRAVELERS' />
            </Link>
          </li>
          <li>
            <Link
              to={ 'url(storefront, language, routeCodes.USER_PROFILE_HOME)' }
              onClick={ () => onProfileLinkClick(3) }
              className='HeaderMenuHamburger-link HeaderMenuHamburger-link--secondary'>
              <TranslatedCopy copyID='USER_PROFILE_MY_CLUB_PREMIER' />
            </Link>
          </li>
        </ul>
        { this.renderLastProfile() }
      </div>
    );
  }

  renderLastProfile() {
    const { onSignOutClick } = this.props;
    return (
      <ul className='HeaderMenuHamburger-linksList HeaderMenuHamburger-linksList--logout'>
        <button
          className='HeaderMenuHamburger-link HeaderMenuHamburger-link--secondary Icon Icon--logout'
          onClick={ onSignOutClick }>
          <TranslatedCopy copyID='APP_LOGOUT' />
        </button>
      </ul>
    );
  }

  renderUser() {
    const {
      isSignedIn,
    } = this.props;

    return (
      <div className='HeaderMenuHamburger-user'>
        { isSignedIn ? this.renderUserProfile() : this.renderUserLogin() }
      </div>
    );
  }

  renderUserLogin() {
    return (
      <a href='#' className='HeaderMenuHamburger-loggedOut'>
        <TranslatedCopy copyID='APP_LOGIN' />
      </a>
    );
  }

  renderUserProfile() {
    const { closeHamburger } = this.props;
    return (
      <div className='HeaderMenuHamburgerProfile' onClick={closeHamburger}>
        <ul className='HeaderMenuHamburgerProfile-linkList'>
          <li>
            <img src='../images/tmp/profile-temp.png' alt='Marge' />
            <Link
              to='/profile/my-aeromexico'
              className='HeaderMenuHamburgerProfile-link'>
              <TranslatedCopy copyID='APP_MY_AEROMEXICO' />
            </Link>
          </li>
          <li>
            <Link
              to='/profile/my-club-premier'
              className='HeaderMenuHamburgerProfile-link'>
              <TranslatedCopy copyID='APP_CLUB_PREMIER' />
            </Link>
          </li>
          <li>
            <Link
              to='/profile/settings'
              className='HeaderMenuHamburgerProfile-link'>
              <TranslatedCopy copyID='APP_SETTINGS' />
            </Link>
          </li>
        </ul>
        <div className='HeaderMenuHamburgerProfile-logout'>
          <button className='Icon Icon--logout'><TranslatedCopy copyID='APP_LOGOUT' /></button>
        </div>
      </div>
    );
  }

  renderHelp() {
    const {
      onOpenChat,
      storefrontData: {
        contactNumber,
      },
    } = this.props;

    return (
      <div className='HeaderMenuHamburger-wrapLinksList'>
        <div className='HeaderMenuHamburger-helpTitle'><TranslatedCopy copyID='APP_NEED_HELP' /></div>
        <ul className='HeaderMenuHamburger-helpList'>
          <li className='HeaderMenuHamburger-helpListItem'>
            <a href={ `tel://${contactNumber}` }
              className='HeaderMenuHamburger-helpBtn Icon Icon--phone'>
              <TranslatedCopy copyID='APP_CALL_US' spaceAfter={ true } />

            </a>
          </li>
          <li className='HeaderMenuHamburger-helpListItem'>
            <button
              className='HeaderMenuHamburger-helpBtn Icon Icon--chat'
              onClick={ () => onOpenChat() }>
              <TranslatedCopy copyID='APP_CHAT_NOW' />
            </button>
          </li>
        </ul>
      </div>
    );
  }

  /* Event Handlers */
  handleProfileClick() {
    this.setState(({ showProfileMenu }) => ({
      showProfileMenu: !showProfileMenu,
    }));
  }

  /**
   * Open storefront menu
   */
  handleStorefrontClick() {
    this.setState({
      isStorefrontActive: false,
    });
  }

  /**
   * Save and close storefront
   */
  handleSaveStorefront() {
    this.props.closeHamburger();

    this.setState({
      isStorefrontActive: false,
    });
  }
}

HeaderMenuHamburger = connect( mapStateToProps)(HeaderMenuHamburger);

export default withWindow(HeaderMenuHamburger);
